
<div class="container-inapp  d-flex flex-column container-white p-3">
    <div class="title px-3 d-flex justify-content-center align-items-center my-3">
        <span class="text-center">{{"BUTTON_ACTION.CANCEL" | translate}}</span>
    </div>

    <div class="content d-flex justify-content-center py-4">
        <span class="px-3 text-center">{{"ORDER.CANCEL_ORDER_MESSAGE" | translate}}</span>
    </div>

    <div class="actions m-3 ">
        <div class="d-flex  justify-content-center align-items-center gap-default">
            <forrest-btn color="btn-white" class="w-50" [title]="('BUTTON_ACTION.NO' | translate)" size="xxl" mat-dialog-close>
            </forrest-btn>
            <forrest-btn color="btn-dark" class="w-50" [title]="('BUTTON_ACTION.YES' | translate)"  size="xxl" (click)="goHome()">
            </forrest-btn>
        </div>
    </div>

</div>
